// Guards against the "dead page" bug: the whole page (nav included) stops
// responding to clicks after certain modal/drawer flows.
//
// Reka's DismissableLayer (used by every UModal and, through vaul-vue, every
// UDrawer) sets `document.body.style.pointerEvents = 'none'` while a dialog is
// open and restores the ORIGINAL value when the last one closes. When several
// dialogs transition in the same tick — e.g. the global search modal concealed
// under a speaker drawer, then a session drawer taking over on a single
// navigation — that restore races and captures `'none'` as the "original",
// leaving the body inert (pointer-events:none, overflow:hidden) with NO dialog,
// layer, or overlay left in the DOM. Nothing ever clears it, so the page freezes.
//
// This is a reka-internal stacking race we can't fix at the source, so we watch
// document.body: the instant its inline lock styles are present with zero open
// dialogs, we clear them. When a dialog IS open the styles are legitimate and we
// leave them alone. The app locks scrolling via `html.locked`/`modal-locked`
// CLASSES on <html>, never body inline styles, so clearing these is safe.
export default defineNuxtPlugin(() => {
    if (!import.meta.client) return;

    const clearIfStuck = () => {
        // A dialog is genuinely open — the lock is correct, leave it.
        if (document.querySelector('[role="dialog"]')) return;
        const s = document.body.style;
        if (s.pointerEvents === 'none') s.pointerEvents = '';
        if (s.overflow === 'hidden') s.overflow = '';
    };

    // Fires when reka mutates body's style (the stuck value is set here) and when
    // a dialog's portal is added/removed from body. Both are the moments the lock
    // could be left dangling; the guard is a cheap check, so run it on either.
    const observer = new MutationObserver(clearIfStuck);
    observer.observe(document.body, { attributes: true, attributeFilter: ['style'], childList: true });
});
